export const getYear = state => state.reportCarrierScoring.getIn(['list', 'year'])
export const getData = state => state.reportCarrierScoring.getIn(['list', 'data'])
export const getFetching = state => state.reportCarrierScoring.getIn(['list', 'fetching'])
export const getError = state => state.reportCarrierScoring.getIn(['list', 'error'])

export const getCarrierScoringData = state => state.reportCarrierScoring.getIn(['scoring', 'data'])
export const isCarrierScoringFetching = state => state.reportCarrierScoring.getIn(['scoring', 'fetching'])
export const isCarrierScoringSaving = state => state.reportCarrierScoring.getIn(['scoring', 'saving'])
export const getCarrierScoringError = state => state.reportCarrierScoring.getIn(['scoring', 'error'])
